<!-- <section class="flex w-full">
  <div class="w-5rem">
    <div class="flex justify-content-start align-items-center">
      <p-avatar icon="pi pi-user" styleClass="mr-2" size="xlarge" shape="circle" *ngIf="!userData.user.selfie_photo_url"></p-avatar>
      <p-avatar [image]="userData.user.selfie_photo_url" styleClass="mr-2 border-round-xl" size="xlarge" shape="circle" *ngIf="userData.user.selfie_photo_url"></p-avatar>
    </div>
  </div>
  <div class="w-auto">
    <div class="flex flex-column justify-content-center">
      <div class="flex">
        <span>Hola&nbsp;<label class="font-bold">{{ userData.user.first_name}} {{ userData.user.last_name}}</label></span>
      </div>
      <div class="flex justify-content-start">
        <span class="mt-2 mr-2 font-bold">Tu nivel actual</span><p-badge [value]="userData.user.level.level" size="large" class="mt-1"></p-badge>
      </div>
    </div>
  </div>
</section> -->


<div class="profile">
  <div class="profile__container">
    <div class="top">
      <div class="profile__image">
        <p-avatar icon="pi pi-user" *ngIf="!userData.user.selfie_photo_url"></p-avatar>
        <p-avatar [image]="userData.user.selfie_photo_url" *ngIf="userData.user.selfie_photo_url"></p-avatar>
      </div>

      <div class="profile__info">
        <p>{{ userData.user.first_name}} {{ userData.user.last_name}}</p>
        <div class="profile__role">
          <span>{{ userData.user.role.name}}</span>
        </div>
      </div>
    </div>

    <div class="bottom">
      <div class="profile__store">
        <span>{{ userData.store?.name}}</span>
      </div>

      <div class="profile__level">
        <p>Nivel actual</p>
        <p-badge [value]="userData.user.level.level"></p-badge>
      </div>

      <!-- <div class="profile__date">
        <span>{{ formattedDate }}</span><span>{{ formattedTime }}</span>
      </div> -->
    </div>
  </div>

  <div class="profile__menu">
    <p-accordion expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up" [multiple]="false">
      <p-accordionTab class="menu__profileItems" iconPos="end">
        <ng-template pTemplate="header">
          <div class="menu__profileHeader">
            <div class="text">
              <p>Configuración de perfil</p>
            </div>
            <div class="arrow">
              <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 2L9.5 8.81818L2 2" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="content">
          <div class="menu__profileBody">
            <div class="item">
              <button pButton type="button" (click)="gotoChangePassword()">
                <i class="pi pi-lock"></i>
                <span>Cambiar contraseña</span>
              </button>
            </div>
            <div class="item">
              <button pButton type="button" (click)="gotoLogout()">
                <i class="pi pi-sign-out"></i>
                <span>Cerrar Sesión</span>
              </button>
            </div>
          </div>
        </ng-template>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
